import * as React from "react";

export interface ILoadingSpinner {
    showSpinner: boolean;
    loadingText: string;
}

export const LoadingSpinner = (props: ILoadingSpinner) => {
    if (props.showSpinner) {
        return (
            <div className="CMS_loadingSpinner" title={props.loadingText} aria-hidden="true"><div className="CMS_ls_spin"></div></div>
        );
    } else {
        return null;
    }
};
